export const checkList = [
  'Cuenta con un módulo adicional de estadísticas financieras.',
  'Accede a métricas de pacientes nuevos y atendidos, analizando periodos ilimitados.',
  'Organiza tus prestaciones por profesionales y seguros médicos para una gestión más eficiente.',
  'Analiza presupuestos emitidos sin límite de periodo. ',
];
